<div class="content">

    <mat-card appearance="outlined" style="background-color: #1ea9d322;">
        <mat-card-content>
            <div style="margin-bottom: 20px;">
                <mat-label style="margin-right: 20px;">Write Type</mat-label>
                <mat-button-toggle-group value="WriteType.overwrite" name="writeType" aria-label="Write Type">
                    <mat-button-toggle value="WriteType.overwrite">Overwrite</mat-button-toggle>
                    <mat-button-toggle value="WriteType.update">Update</mat-button-toggle>
                    <mat-button-toggle value="WriteType.new">New</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            <div>
                <mat-form-field style="width: 350px" appearance="outline">
                    <mat-label>Data Source</mat-label>
                    <input [(ngModel)]="viewModel.dataSource" matInput type="text">
                </mat-form-field>
            </div>
            <div>
                <mat-form-field style="width: 350px" appearance="outline">
                    <mat-label>Target Location</mat-label>
                    <input [(ngModel)]="viewModel.targetLocation" type="text" matInput
                        placeholder="Enter target location">
                </mat-form-field>
            </div>
        </mat-card-content>
    </mat-card>
</div>